import React, {useContext, useEffect} from 'react';
import {Button, Space} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {StoreContext} from "../../../store.context";
import * as User from "../../../modules/user";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import {useNavigate} from "react-router-dom";
import AccessUtil from "../../../components/util/access.util";
import {Helmet} from "react-helmet-async";
import {TranslationDomainEnum} from "../../../types/enums";

export const List: React.FC = observer(() => {
    const { appStore: { translate } } = useContext(StoreContext);
    const translationDomain = TranslationDomainEnum.USER_ADMINISTRATION;
    const title = translate('user.title.user_management', {}, translationDomain);

    const { appStore: {
        moduleStore: {
            userStore: {
                setTableFilterData,
                list
            }
        }
    } } = useContext(StoreContext);

    const navigate = useNavigate();
    const onSubmit = (values: any) => {
        setTableFilterData && setTableFilterData(values);
        list();
    };

    useEffect(() => {
        list();
    }, [list])

    return (
        <React.Fragment>
            <Helmet>
                <title>{`CL BO - ${title}`}</title>
            </Helmet>
            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                <User.FilterForm onSubmit={onSubmit} onReset={() => onSubmit([])} />

                <CardStyled title={<Translate message={`global.title.search_results`} />}>
                    <User.FilterTable />
                </CardStyled>
            </Space>
            <AccessUtil access={{ routeName: 'user_add', attributes: [] }}>
                <ButtonBar>
                    <Button type="primary" htmlType={`button`} onClick={() => {
                        navigate("/user/add");
                    }}><Translate message={`global.button.add`} /></Button>
                </ButtonBar>
            </AccessUtil>
        </React.Fragment>
    )
})